
export default class PhotoSwipeGallerySlide {
    constructor() {
        this.w = 0;
        this.h = 0;
        this.src = '';
        this.title = '';
        this.pid = '';
        this.gid = '';
        this.thumbnailContainer = null;
        this.msrc= '';
    }

    hash() {
        return this.gid + this.src;
    }
}



// WEBPACK FOOTER //
// ./frontend/js/PhotoSwipeGallerySlide.js